import { type PropsWithChildren } from "react";

import Typography, { type TypographyProps } from "@/components/flowbite/typography/typography";

interface IProps extends PropsWithChildren, Omit<TypographyProps, "children"> {
  subTitle?: string;
}

const FormTitle = ({ children, subTitle, ...typographyProps }: IProps) => {
  return (
    <div className="flex flex-col gap-4">
      <Typography.H3 {...typographyProps}>{children}</Typography.H3>

      { subTitle && <Typography.SubTitle>{subTitle}</Typography.SubTitle> }
    </div>
  );
};

export default FormTitle;
